import React from 'react';
import { Box } from '@material-ui/core';
import FsCopyPasteInput from 'ui-elements/form-elements/FsCopyPasteInput';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';

export interface KeysSingleField {
  name: string;
  value: string;
  type?: 'password';
}

export interface FsKeysGroupFormDataProps {
  fields: KeysSingleField[];
}

export interface FsKeysGroupFormProps extends FsKeysGroupFormDataProps {
  title: string;
}

const FsKeysGroupForm: React.FC<FsKeysGroupFormProps> = ({ title, fields }) => {
  return (
    <Box maxWidth={600}>
      {fields.map(({ name, value, type }) => (
        <FsFormFullWidthContainer key={name}>
          <FsCopyPasteInput
            fullWidth
            label={name}
            name={`${title} ${name}`}
            value={value}
            type={type}
          />
        </FsFormFullWidthContainer>
      ))}
    </Box>
  );
};

export default FsKeysGroupForm;
